/* eslint-disable max-classes-per-file */
import { TypeHelper } from '../TypeHelper';

export enum ContentCategory {
  Image,
}

export enum ContentType {
  jpeg,
  png,
  bmp,
  tiff,
  heic,
  plainText,
  json,
  pdf,
  mp4,
  m4v,
  mov,
  webm,
}

export class ContentTypeHelper {
  public static readonly allContentTypes = [
    ContentType.jpeg,
    ContentType.png,
    ContentType.bmp,
    ContentType.tiff,
    ContentType.heic,
    ContentType.plainText,
    ContentType.json,
    ContentType.pdf,
  ];

  public static getExtensions(ctype: ContentType): string[] {
    // order is important
    return [
      ['jpg', 'jpeg'], // jpeg
      ['png'],
      ['bmp'],
      ['tiff'],
      ['heic'],
      ['txt', 'text'], // plainText
      ['json'],
      ['pdf'],
    ][ctype];
  }
  public static getCategory(ctype: ContentType): ContentCategory {
    // order is important
    return [
      ContentCategory.Image, // jpg
      ContentCategory.Image, // png
      ContentCategory.Image, // bpm
      ContentCategory.Image, // tiff
      ContentCategory.Image, // heic
    ][ctype];
  }

  public static getAllByCategory(cat: ContentCategory): ContentType[] {
    return ContentTypeHelper.allContentTypes.filter(
      (t) => ContentTypeHelper.getCategory(t) === cat,
    );
  }

  public static parseContentType(ctype: string): ContentType | undefined {
    switch (ctype) {
      case 'image/jpg':
      case 'image/jpeg':
        return ContentType.jpeg;
      case 'image/png':
        return ContentType.png;
      case 'image/tiff':
        return ContentType.tiff;
      case 'image/bmp':
        return ContentType.bmp;
      case 'text/plain':
        return ContentType.plainText;
      case 'text/json':
        return ContentType.json;
      case 'application/pdf':
      case 'application/x-pdf':
        return ContentType.pdf;
      default:
        return undefined;
    }
  }

  public static parseExtension(fileName: string): ContentType | undefined {
    if (!fileName) {
      return undefined;
    }
    const i = fileName.lastIndexOf('.');
    const ext = i >= 0 ? fileName.substr(i + 1) : fileName;

    if (!ext) {
      return undefined;
    }

    return ContentTypeHelper.allContentTypes.find(
      (ctype) =>
        !!ContentTypeHelper.getExtensions(ctype).find((t) =>
          TypeHelper.safeStringEquals(t, ext, true, true),
        ),
    );
  }

  public static async convertBlobToBase64(blob: Blob): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);

      reader.readAsDataURL(blob);
    });
  }
}

class ContentRef {
  public readonly contentType: ContentType;
  public readonly name: string;
}
export class Content {
  public readonly contentRef: ContentRef;
  public readonly size: number;
  public readonly data: Blob | string | null;
  public readonly dataBase64?: string | undefined | null; // sometimes we pre-calculate this to optimize rendering (to avoid async render)
}
